import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function Advertisers() {
  const Ads = [
    {
      id: '01',
      image: '/slacabaret-2022/ads/werners.jpg',
      link: 'https://wernersmercedes.com/?utm_source=Mills+Publishing+Digital+Publications&utm_campaign=Salt+Lake+Acting+Company',
      alt: 'Werner Mercedes',
      class: 'webFormat',
    },
    {
      id: '02',
      image: '/slacabaret-2022/ads/sl-mercedes.jpg',
      link: 'https://www.kengarffmercedes.com/?utm_source=Mills+Publishing+Digital+Publications&utm_campaign=Salt+Lake+Acting+Company',
      alt: 'Mercedes-Benz of Salt Lake City',
      class: 'webFormat',
    },
    {
      id: '03',
      image: '/slacabaret-2022/ads/neil-glover-wing-coop.jpg',
      link: '#',
      alt: 'Neil Glover and Wing Coop',
      class: 'webFormat',
    },
  ];

  // Grab the Ads array and sort each object alphabetically by the alt property/string, if a > b, move the object back in order in the array, if a < b than more the object up in the order of the array.
  const sortedAds = Ads.sort((a, b) => (a.alt > b.alt ? 1 : -1));

  return (
    <div>
      {sortedAds.map((data) => (
        <details key={data.id}>
          <summary>{data.alt}</summary>
          <OutboundLink
            href={data.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={data.image} alt={data.alt} className={data.class} />
          </OutboundLink>
        </details>
      ))}
    </div>
  );
}

export default Advertisers;
